import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

import { Loader } from '@/components/loaders/Loader'
import { fetchOrganizationData } from '@/reducers/organizations/organization.actions'
import { fetchTagBoard } from '@/reducers/organizations/organizationTagManager.actions'
import { setCategories } from '@/reducers/organizations/organizationTagManager.redux'

import TagForm from './components/tags/TagForm'

import './TagPage.scss'

const TagPage = () => {
  const dispatch = useDispatch()
  const routeParams = useParams()
  const [loading, setLoading] = useState(true)
  const { edit_users: editUsers, organizationid: userOrganizationId } = useSelector(
    (state) => state.currentUser
  )
  const organizationTags = useSelector((state) => state.organizationTagManager)
  const { users } = useSelector((state) => state.organizationUsers)
  const organization = useSelector((state) => state.organization)

  const fetchCategoriesAndTags = (orgId) => fetchTagBoard({ organizationId: orgId })

  useEffect(() => {
    const orgId = routeParams?.organizationid ? routeParams.organizationid : userOrganizationId
    const loadPage = async () => {
      dispatch(setCategories([]))
      await Promise.all([
        dispatch(fetchOrganizationData({ organizationId: orgId })),
        dispatch(fetchCategoriesAndTags(orgId)),
      ])
      setLoading(false)
    }
    loadPage()
  }, [])

  return (
    <div className="manage-tags">
      {loading && (
        <div className="loading-overlay">
          <Loader />
        </div>
      )}
      <TagForm
        tags={organizationTags}
        organizationId={organization.id}
        fetchCategoriesAndTags={fetchCategoriesAndTags}
        users={users}
        name={organization.name}
        userOrganizationId={userOrganizationId}
        edit_users={editUsers}
      />
    </div>
  )
}

export default withLDConsumer()(TagPage)
